import axios from 'axios'
import React, { Component } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import Cookies from 'universal-cookie'
import Contenido from '../components/contenido/Contenido'
import FooterDashboard from '../components/footer/FooterDashboard'
import NavbarGeneral from '../components/navbar/NavbarGeneral'
import Sidebar from '../components/sidebar/SidebarGestorPlataforma'
import VerPerfil from '../components/gestorplataforma/perfil/VerPerfil'
import ListaMatri from '../components/gestorplataforma/matriculas/ListaMatriculados'
import GestionCreditosExtra from '../components/gestorplataforma/creditos_extra/GestionCreditosExtra'
import GestionDocenteCreditos from '../components/gestorplataforma/creditos_extra/GestionDocenteCreditos'
import GestionEstudianteCreditos from '../components/gestorplataforma/creditos_extra/GestionEstudianteCreditos'

import { ApiUrl } from '../components/services/ApiRest';

const cookie = new Cookies();
const urlAdministrativo=ApiUrl +"admins/"; //pasar id del estudiante
const idAdministrativo = cookie.get("idAdministrativo");    //declaramos una variable para usar la cookie del login

const config = {
    headers: { Authorization: `Bearer ${cookie.get("rol")}` }
};

export default class RutasVicerrectoradoAdm extends Component {
    componentDidMount() {
      
        axios.get(urlAdministrativo+idAdministrativo+"?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71")
          .then(res => {
            const estudiante = res.data;
            this.setState({ estudiante });
            cookie.set('nombres',estudiante.nombres_administrativo,{path:"/"})
            cookie.set('apellidos',estudiante.apellidos_administrativo,{path:"/"})
          })
    }    

    render() {
        if(!cookie.get("log")){
            return(<Redirect to="/login" />);
        }

        if(cookie.get("rol") !== "administrativo"){
        }

        return (
            
            <>
                <NavbarGeneral /> 
                <div id="layoutSidenav" >
                    <Sidebar />
                    <div id="layoutSidenav_content">
                        <main>
                        
                            <div className="container-fluid">                       
                                  {this.props.location.pathname === "/gestorplataforma" && <Contenido />}
                                    {/* Matriculas */}
                                  <Route path="/gestorplataforma/VerPerfilGestorP" component={VerPerfil} /> 
                                   <Route path="/gestorplataforma/listmatriculados" component={ListaMatri} />
                                   {/* Matriculas */}
                                   <Route path="/gestorplataforma/GestionCreditosExtra" component={GestionCreditosExtra} />
                                   <Route path="/gestorplataforma/GestionDocenteCreditos" component={GestionDocenteCreditos} />
                                   <Route path="/gestorplataforma/GestionEstudianteCreditos" component={GestionEstudianteCreditos} />
                             </div>
                        </main>
                        <FooterDashboard />                        
                    </div>                 
                </div>            
            </>
        )
    }
}
